import React from "react";
import { Route,Switch } from "react-router-dom";
import HomeRoute from "./home";
import CallbackRoute from "./callback";

export function Content() {
  return (
    <Switch>
      <Route path={`/auth/callback`} component={CallbackRoute} />
      <Route path={`/auth`} component={HomeRoute} />
    </Switch>
  );
}

